import { ArrowRight, ExternalLink, ShieldCheck } from "lucide-react";
import { Shell } from "./Shell";
import { FadeUp } from "./Sections";

const QGIV_URL = "https://secure.qgiv.com/for/houstonadvancedresearchcenter";

export default function Donate() {
  return (
    <Shell>
      <div data-testid="donate-page">
        <section className="mx-auto max-w-7xl px-6 pt-16 md:pt-24">
          <FadeUp>
            <p className="mb-5 flex items-center text-xs font-bold uppercase tracking-[0.18em] text-[#004778]">
              <span className="mr-2.5 inline-block h-2.5 w-2.5 bg-[#FFA100]" aria-hidden="true" />
              Support HARC
            </p>
            <h1 className="harc-heading max-w-3xl text-4xl font-medium leading-[1.1] tracking-tight text-[#004778] md:text-6xl">
              Help Turn Science Into Solutions
            </h1>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#5C6B72] md:text-lg md:font-light">
              Your support helps transform independent research into practical solutions that build
              a sustainable future.
            </p>
            <a href="#give" className="mockup-link-arrow mt-8" data-testid="donate-now-cta">
              Donate Now <ArrowRight size={15} aria-hidden="true" />
            </a>
          </FadeUp>
        </section>

        <section id="give" className="mx-auto max-w-7xl px-6 py-20 md:py-28">
          <div className="grid gap-10 md:grid-cols-12">
            <FadeUp className="md:col-span-7">
              <div
                className="border border-[#004778]/25 bg-white"
                data-testid="donate-embed-frame"
              >
                <div className="brand-stripe" aria-hidden="true" />
                <div className="flex min-h-[420px] flex-col items-center justify-center gap-4 p-10 text-center">
                  <ShieldCheck size={30} className="text-[#004778]" aria-hidden="true" />
                  <p className="harc-heading text-xl text-[#004778]">Secure donation form</p>
                  <p className="max-w-md text-sm leading-relaxed text-[#5C6B72]">
                    [The existing secure Qgiv donation form embeds here in production. The current
                    provider is retained; no new payment processing is introduced.]
                  </p>
                  <a
                    href={QGIV_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-2 inline-flex items-center gap-2 rounded-full bg-[#FFA100] px-6 py-3 text-xs font-bold uppercase tracking-[0.12em] text-[#022A42] transition-colors hover:bg-[#D98A00]"
                    data-testid="donate-qgiv-link"
                  >
                    Preview the live Qgiv page <ExternalLink size={13} aria-hidden="true" />
                  </a>
                </div>
              </div>
            </FadeUp>
            <FadeUp delay={0.12} className="md:col-span-5">
              <div className="border border-[#004778]/25 bg-white p-8" data-testid="donate-other-ways">
                <h2 className="harc-heading text-2xl font-medium text-[#004778]">
                  Other Ways to Give
                </h2>
                <p className="mt-4 text-sm leading-relaxed text-[#5C6B72]">
                  [HARC CONTENT REQUIRED: contact information for other giving options, such as
                  checks, stock transfers, employer matching, or planned giving.]
                </p>
              </div>
              <p className="mt-6 text-xs italic leading-relaxed text-[#5C6B72]">
                Donations are processed securely by HARC's existing provider. HARC is a 501(c)(3)
                nonprofit research organization.
              </p>
            </FadeUp>
          </div>
        </section>
      </div>
    </Shell>
  );
}
